import linkData from '@/base/linkData'
export default {
  contact_us_set: {
    radio_val: 'default',
    default: {
      id: 'default-0',
      borderRadius: '50%',
      canChangeColor: true,
      backgroundColor: 'rgba(55, 85, 239, 1)',
      iconPosition: '-0 -0'
    },
    customSet: {
      url: 'https://preapiconsole.71360.com/file/read/www/M00/01/60/wKgBbF5F-HSAaMfQAAArKq7c-fY663.jpg'
    }
  },
  listArr: {
    link: {
      ...linkData,
      linkType: 'fun',
      fun: { // �����ܡ�
        ...linkData.fun,
        jump_section: { // ������ͨ��/ģ��ê�㡿
          type: 'other_page', // ��ת����
          cur_page_value: '', // ��ǰҳ��ê��
          other_page_value: '', // ����ҳ��ê��
          site_section: {} //��վ��Ŀ
        }
      },
    }
  }
}


// WEBPACK FOOTER //
// ./src/view/contact_us/style.js